<script setup lang="ts">
import { computed, Ref, unref } from 'vue'

const props = defineProps<{
  loading?: boolean | Ref<boolean>
  disableReason?: string
}>()
const emit = defineEmits<{
  click: [event: MouseEvent]
}>()

const isLoading = computed(() => unref(props.loading))
const disabled = computed(() => !!props.disableReason)
// The event is passed on: menus use this button as their activator and read it
const onClick = (event: MouseEvent) => {
  if (disabled.value) {
    return
  }

  emit('click', event)
}
</script>

<template>
  <v-btn
    density="compact"
    icon="add"
    :color="disabled ? 'grey' : 'primary'"
    :class="{ 'cursor-not-allowed': disabled }"
    :title="props.disableReason"
    :loading="isLoading"
    @click="onClick"
  />
</template>

<style scoped lang="scss"></style>
